import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Select } from '@agconnections/grow-ui';
import { waterOrigins } from '../DataSets';

const WaterOrigin = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      control={Select}
      id="waterOrigin"
      name="waterOrigin"
      items={waterOrigins}
      label="Water Origin"
      disabled={!isEnableInfoTabEdit}
      placeholder="Select water origin"
    />
  );
};

export default WaterOrigin;
